/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const PremiumTechSupport = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--premiumTechSupport"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99967 1.33334C4.60644 1.33334 2.66634 3.27344 2.66634 5.66668V7.36668C1.90559 7.52111 1.33301 8.19369 1.33301 9.00001V10.3333C1.33301 11.1397 1.90559 11.8122 2.66634 11.9667V12.3333C2.66634 13.622 3.71101 14.6667 4.99967 14.6667H8.66634V13.3333H4.99967C4.44739 13.3333 3.99967 12.8856 3.99967 12.3333V11.9667C4.76042 11.8122 5.33301 11.1397 5.33301 10.3333V9.00001C5.33301 8.19369 4.76042 7.52111 3.99967 7.36668V5.66668C3.99967 4.00982 5.34282 2.66668 6.99967 2.66668H8.99967C10.6565 2.66668 11.9997 4.00982 11.9997 5.66668V7.36668C11.2389 7.52111 10.6663 8.19369 10.6663 9.00001V10.3333C10.6663 11.2538 11.4125 12 12.333 12H12.9997C13.9201 12 14.6663 11.2538 14.6663 10.3333V9.00001C14.6663 8.19369 14.0938 7.52111 13.333 7.36668V5.66668C13.333 3.27344 11.3929 1.33334 8.99967 1.33334H6.99967ZM2.99967 8.66668H3.66634C3.85044 8.66668 3.99967 8.81592 3.99967 9.00001V10.3333C3.99967 10.5174 3.85044 10.6667 3.66634 10.6667H2.99967C2.81558 10.6667 2.66634 10.5174 2.66634 10.3333V9.00001C2.66634 8.81592 2.81558 8.66668 2.99967 8.66668ZM12.9997 8.66668H12.333C12.1489 8.66668 11.9997 8.81592 11.9997 9.00001V10.3333C11.9997 10.5174 12.1489 10.6667 12.333 10.6667H12.9997C13.1838 10.6667 13.333 10.5174 13.333 10.3333V9.00001C13.333 8.81592 13.1838 8.66668 12.9997 8.66668Z"
        fill="white"
      />
      <path
        d="M8.31663 4.64236C8.21685 4.33526 7.78238 4.33526 7.6826 4.64236L7.25124 5.96995H5.85532C5.53241 5.96995 5.39815 6.38316 5.65939 6.57296L6.78871 7.39346L6.35735 8.72105C6.25757 9.02815 6.60906 9.28353 6.8703 9.09373L7.99962 8.27323L9.12893 9.09373C9.39017 9.28353 9.74166 9.02815 9.64188 8.72105L9.21052 7.39346L10.3398 6.57296C10.6011 6.38316 10.4668 5.96995 10.1439 5.96995H8.74799L8.31663 4.64236Z"
        fill="white"
      />
    </svg>
  );
};

PremiumTechSupport.displayName = "premiumTechSupport";

export default PremiumTechSupport;
